var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('svg-icon',{attrs:{"icon-class":"404"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }